import { render } from "./HistoryListHeader.vue?vue&type=template&id=224bec26&ts=true"
import script from "./HistoryListHeader.vue?vue&type=script&lang=ts"
export * from "./HistoryListHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__